<template>
  <DefaultLayout background-image="morePeople">
    <div
      class="flex justify-between flex-col items-center px-2 h-full pt-[4.5rem] pb-36"
    >
      <div class="leading-none text-center font-regular text-jm_white">
        <img :src="logo" alt="logo" class="w-[100px]" />
      </div>

      <div class="flex flex-col items-center justify-center px-10">
        <div
          class="font-bold uppercase leading-none text-[2.1rem] mb-2 text-jm_white text-center"
        >
          {{ $t("thats_enough.thats_enough") }}
        </div>

        <div
          class="px-2 text-[1.1rem] leading-7 text-jm_white mb-2 text-center"
        >
          {{ $t("thats_enough.thanks_for_playing") }}
        </div>
        <span
          @click="handleEnoughClick"
          v-if="globalStore.timesLeftToPlay === 0"
          class="flex items-center justify-center px-2 py-3 mt-4 text-sm font-bold rounded-lg cursor-pointer w-72 min-h-10 bg-jm_white"
          >GOT IT</span
        >
      </div>
    </div>
  </DefaultLayout>
</template>

<script lang="ts" setup>
import DefaultLayout from "../layouts/DefaultLayout.vue";
import logo from "@/assets/images/misc/logo_jaegermeister_white.svg";
import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";

const globalStore = useGlobalStore();
const { kpiTracker } = useGameTracking();

const handleEnoughClick = () => {
  globalStore.changeStep("ageCheck");
  globalStore.playTapSound();
  globalStore.setShouldShowDailyLimitScreen(false);
  globalStore.setCapturedPhotoFile(null);
  globalStore.setCapturedPhotoDataUrl(null);
  globalStore.setUploadedPhotoItemId(null);
  kpiTracker.resetGame();
  kpiTracker.resetTrackingData();
  globalStore.resetGame(kpiTracker.selectedPerson.value);
};
</script>
